import { render, staticRenderFns } from "./selectDictionary.vue?vue&type=template&id=1cddd77a&scoped=true&"
import script from "./selectDictionary.vue?vue&type=script&lang=js&"
export * from "./selectDictionary.vue?vue&type=script&lang=js&"
import style0 from "./selectDictionary.vue?vue&type=style&index=0&id=1cddd77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddd77a",
  null
  
)

export default component.exports